import {Property} from 'csstype';
import * as React from 'react';
import {Scales} from '../../types';
import {theme} from '../style';

interface BackgroundLabelProps {
  labels: string[];
  location: {x: number; y: number};
  scales: Scales;
  fontFamily?: Property.FontFamily;
  fontSize?: Property.FontSize<number>;
  fill?: Property.Fill;
  fontWeight?: Property.FontWeight;
}

/**
 * Background chart label.  Use for example to draw a label for a highlighted section or grid.
 *
 * @param labels - array of line break-ed words to use for the label
 * @param location - x/y (chart coordinates) of location to draw the label
 * @param scales - chart scales
 * @param fontFamily - font family to use. default to theme
 * @param fontSize - font size to use. default to 23
 * @param fill - fill to use. default to theme
 * @param fontWeight - weight to use. default to bold
 *
 */
export const BackgroundLabel = ({
  labels,
  location,
  scales,
  fontFamily = theme.fonts.primaryFontFamily,
  fontSize = 23,
  fill = theme.colors.chartTextSecondary,
  fontWeight = 'bold',
}: BackgroundLabelProps) => (
  <text
    x={scales.xScale(location.x)}
    y={scales.yScale(location.y)}
    fontFamily={fontFamily}
    fontSize={fontSize}
    fill={fill}
    fontWeight={fontWeight}>
    {labels.map((l, i) => (
      <tspan x={scales.xScale(location.x)} dy="1.2em" key={i}>
        {l}
      </tspan>
    ))}
  </text>
);
